import React from "react";
import { authRoles } from "../../auth/authRoles";

const workBenchRoutes = [
    {
        path: "/workbench",
        component: React.lazy(() => import("./WorkBenchPanel")),
        auth: authRoles.sa,
    },
];

export default workBenchRoutes;
